import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useEffect } from 'react';
import { assertText, datetimeSimplifier } from "../../redux/conversation/conversationSlice";
import { SurveyInfo, SurveyType } from "../../redux/survey/surveySlice";
import { useSelector } from "react-redux";
import { retrieveSurveyQuestionAnswerList, selectSurveyQuestionAnswerList, surveyQuestionAnswerListSlice } from "../../redux/survey/surveyQuestionAnswerListSlice";
import { useAppDispatch } from "../../app/hooks";
import SurveyResultRow from "./SurveyResultRow";
import PrizaContainer from "../base/grid/PrizaContainer";
import { worstState } from "../../redux/common";

interface SurveyResultProps {
    survey: SurveyInfo;
    onClose: () => void;
}

const SurveyResult: React.FC<SurveyResultProps> = ({ 
    survey, onClose
}) => {
    const dispatch = useAppDispatch();
    const surveyAnswers = useSelector(selectSurveyQuestionAnswerList);

    useEffect(() => {
        if (surveyAnswers.request?.surveyId && surveyAnswers.request?.surveyId != survey.id) {
            dispatch(surveyQuestionAnswerListSlice.actions.clean());
        }
        dispatch(retrieveSurveyQuestionAnswerList({ surveyId: survey.id }) );
    }, [surveyAnswers, survey]);

    const content = () => (
        <Box sx={{ m: 1, px: 2 }}>
            <Typography variant="body2" sx={{ marginTop: "0px", fontSize: "10px", fontStyle: "italic",
                color: (theme) => survey.type === SurveyType.PRIVATE_PER_STUDENT ? theme.palette.text.primary : theme.palette.text.secondary
            }}>
                Um voto por {survey.type === SurveyType.PRIVATE_PER_STUDENT ? "aluno" : "usuário"}
            </Typography>
            <Typography variant="body2" sx={{ marginTop: "0px", fontSize: "10px", fontStyle: "italic",
                color: (theme) => theme.palette.text.secondary
            }}>
                Válido até: {datetimeSimplifier(survey.endAt)}
            </Typography>
            {
                survey.questions && survey.questions.length > 0 &&
                survey.questions.map((question) => {
                    
                    return (
                        <Stack key={`${survey.id}-question-${question.id}`} spacing={2} sx={{ my: 1 }} direction={"column"}>
                            <Paper elevation={10} sx={{ padding: "10px", marginBottom: "10px", backgroundColor: "#f5f5f5" }}>
                                <Typography variant="h6" sx={{ marginTop: "0px" }}>
                                    {question.title}
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: "0px", marginBottom: "3px" }}>
                                    {assertText(question.description)}
                                </Typography>
                                
                                {question.options?.map((option, index) => {
                                    const count = surveyAnswers.list?.filter((answer) => answer.surveyQuestionOptionId === option.id && answer.surveyQuestionId == question.id).length ?? 0;
                                    return <Button key={`preview-option-${index}`} variant="outlined" fullWidth sx={{ mb: 1, textTransform: "none" }}>
                                        {option.title} ({count} votos)
                                    </Button>;
                                })}
                            </Paper>
                            <TableContainer component={Paper} sx={{ m: 1 }}>
                                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" sx={{
                                                    color: (theme) => theme.palette.primary.contrastText,
                                                    backgroundColor: (theme) => theme.palette.primary.main,
                                                }}>Aluno</TableCell>
                                            <TableCell align="left" sx={{
                                                    color: (theme) => theme.palette.primary.contrastText,
                                                    backgroundColor: (theme) => theme.palette.primary.main,
                                                }}>Usuário</TableCell>
                                            <TableCell align="left" sx={{
                                                    color: (theme) => theme.palette.primary.contrastText,
                                                    backgroundColor: (theme) => theme.palette.primary.main,
                                                }}>Resposta</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {surveyAnswers.list?.map((row) => (
                                            <SurveyResultRow key={row.id} answer={row} question={question} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    );
                })
            }
        </Box>
    );

        return <PrizaContainer
            state={worstState([surveyAnswers.state])}
            toolbar={{
                label: "Detalhes da Enquete",
                buttons: [
                    {
                        label: "Fechar",
                        click: () => {
                            onClose();
                        }
                    }
                ]
            }}
            messages={{
                empty: "Nenhuma enquete encontrada.",
                error: "Erro ao carregar detalhes da enquete."
            }}
            content={content}
            retry={() => { 
                dispatch(surveyQuestionAnswerListSlice.actions.clean());
            }}
        />;
    
};

export default SurveyResult;
